import { rem } from "polished";
import { css } from "styled-components";

import { LG_WIDTH } from "./theme/layout";

export const fontFamily = {
  heading: "Sora",
  headingLight: "Sora Light",
  headingBold: "Sora Bold",
  text: "Readex Pro",
  textLight: "Readex Pro Light",
  textBold: "Readex Pro Bold",
};

export const fontWeight = {
  light: 300,
  regular: 400,
  bold: 700,
};

export const mobileFontSize = {
  heading01: 48,
  heading02: 30,
  heading03: 38,
  heading04: 24,
  heading05: 16,
};

export const desktopFontSize = {
  heading01: 56,
  heading02: 44,
  heading03: 46,
  heading04: 24,
  heading05: 16,
};

export const mobileLineHeight = {
  heading01: "121.5%",
  heading02: "121.5%",
  heading03: "121.5%",
  heading04: "121.5%",
  heading05: "150%",
};

export const desktopLineHeight = {
  heading01: "121.5%",
  heading02: "121.5%",
  heading03: "121.5%",
  heading04: "121.5%",
  heading05: "121.5%",
};

export const mobileLetterSpacing = {
  heading01: -1.92,
  heading02: -1.2,
  heading03: -1.52,
  heading04: -0.96,
  heading05: 1.28,
};

export const desktopLetterSpacing = {
  heading01: -2.24,
  heading02: -1.76,
  heading03: -1.84,
  heading04: -0.96,
  heading05: 0.52,
};

export const headings = {
  heading01: css`
    font-family: ${fontFamily.heading};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(mobileFontSize.heading01)};
    line-height: ${mobileLineHeight.heading01};
    letter-spacing: ${rem(mobileLetterSpacing.heading01)};
    margin-bottom: ${rem(12)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(desktopFontSize.heading01)};
      line-height: ${desktopLineHeight.heading01};
      letter-spacing: ${rem(desktopLetterSpacing.heading01)};
    }
  `,
  heading02: css`
    font-family: ${fontFamily.headingLight};
    font-size: ${rem(mobileFontSize.heading02)};
    line-height: ${mobileLineHeight.heading02};
    letter-spacing: ${rem(mobileLetterSpacing.heading02)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(desktopFontSize.heading02)};
      line-height: ${desktopLineHeight.heading02};
      letter-spacing: ${rem(desktopLetterSpacing.heading02)};
    }
  `,
  heading03: css`
    font-family: ${fontFamily.heading};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(mobileFontSize.heading03)};
    line-height: ${mobileLineHeight.heading03};
    letter-spacing: ${rem(mobileLetterSpacing.heading03)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(desktopFontSize.heading03)};
      line-height: ${desktopLineHeight.heading03};
      letter-spacing: ${rem(desktopLetterSpacing.heading03)};
    }
  `,
  heading04: css`
    font-family: ${fontFamily.heading};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(mobileFontSize.heading04)};
    line-height: ${mobileLineHeight.heading04};
    letter-spacing: ${rem(mobileLetterSpacing.heading04)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(desktopFontSize.heading04)};
      line-height: ${desktopLineHeight.heading04};
      letter-spacing: ${rem(desktopLetterSpacing.heading04)};
    }
  `,
  heading05: css`
    font-family: ${fontFamily.heading};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(mobileFontSize.heading05)};
    line-height: ${mobileLineHeight.heading05};
    letter-spacing: ${rem(mobileLetterSpacing.heading05)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(desktopFontSize.heading05)};
      line-height: ${desktopLineHeight.heading05};
      letter-spacing: ${rem(desktopLetterSpacing.heading05)};
    }
  `,
};

export const bodyText = {
  b1impactbold: css`
    font-family: ${fontFamily.text};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(28)};
    line-height: ${rem(34)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(40)};
      line-height: ${rem(60)};
    }
  `,
  b1impact: css`
    font-family: ${fontFamily.heading};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(28)};
    line-height: ${rem(34)};
    letter-spacing: ${rem(-1.12)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(34)};
      line-height: ${rem(41)};
      letter-spacing: ${rem(-1.36)};
    }
  `,
  b2bold: css`
    font-family: ${fontFamily.text};
    font-weight: ${fontWeight.bold};
    font-size: ${rem(22)};
    line-height: ${rem(36)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(28)};
      line-height: ${rem(46)};
    }
  `,
  b2reg: css`
    font-family: ${fontFamily.textLight};
    font-weight: ${fontWeight.light};
    font-size: ${rem(22)};
    line-height: ${rem(36)};
    @media (min-width: ${LG_WIDTH}px) {
      font-weight: ${fontWeight.regular};
      font-size: ${rem(28)};
      line-height: ${rem(46)};
    }
  `,
  b3impact: css`
    font-family: ${fontFamily.heading};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(20)};
    line-height: ${rem(24)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(18)};
      line-height: ${rem(22)};
    }
  `,
  b3bold: css`
    font-family: ${fontFamily.text};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(20)};
    line-height: ${rem(33)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(18)};
      line-height: ${rem(30)};
    }
  `,
  b3reg: css`
    font-family: ${fontFamily.textLight};
    font-size: ${rem(20)};
    line-height: ${rem(33)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(18)};
      line-height: ${rem(30)};
    }
  `,
  b4impactbold: css`
    font-family: ${fontFamily.heading};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(18)};
    line-height: ${rem(22)};
    letter-spacing: 1px;
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(16)};
      line-height: ${rem(26)};
      letter-spacing: initial;
    }
  `,
  b4impactreg: css`
    font-family: ${fontFamily.heading};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(18)};
    line-height: ${rem(22)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(16)};
      line-height: ${rem(26)};
    }
  `,
  b4bold: css`
    font-family: ${fontFamily.text};
    font-size: ${rem(18)};
    line-height: ${rem(30)};
    @media (min-width: ${LG_WIDTH}px) {
      font-weight: ${fontWeight.bold};
      font-size: ${rem(16)};
      line-height: ${rem(26)};
    }
  `,
  b4reg: css`
    font-family: ${fontFamily.textLight};
    font-size: ${rem(18)};
    line-height: ${rem(30)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(16)};
      line-height: ${rem(26)};
    }
  `,
  b5bold: css`
    font-family: ${fontFamily.text};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(17)};
    line-height: ${rem(28)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(15)};
      line-height: ${rem(26)};
    }
  `,
  b5reg: css`
    font-family: ${fontFamily.textLight};
    font-size: ${rem(17)};
    line-height: ${rem(28)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(15)};
      line-height: ${rem(26)};
    }
  `,
  b6impactbold: css`
    font-family: ${fontFamily.heading};
    font-size: ${rem(16)};
    line-height: ${rem(19)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(14)};
      line-height: ${rem(17)};
    }
  `,
  b6impact: css`
    font-family: ${fontFamily.headingLight};
    font-weight: ${fontWeight.light};
    font-size: ${rem(16)};
    line-height: ${rem(19)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(14)};
      line-height: ${rem(17)};
    }
  `,
  b6bold: css`
    font-family: ${fontFamily.text};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(16)};
    line-height: ${rem(26)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(14)};
      line-height: ${rem(23)};
    }
  `,
  b6reg: css`
    font-family: ${fontFamily.textLight};
    font-weight: ${fontWeight.light};
    font-size: ${rem(16)};
    line-height: ${rem(26)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(14)};
      line-height: ${rem(23)};
    }
  `,
  b7bold: css`
    font-family: ${fontFamily.text};
    font-weight: ${fontWeight.regular};
    font-size: ${rem(15)};
    line-height: ${rem(25)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(13)};
      line-height: ${rem(21)};
    }
  `,
  b7reg: css`
    font-family: ${fontFamily.text};
    font-weight: ${fontWeight.light};
    font-size: ${rem(15)};
    line-height: ${rem(25)};
    @media (min-width: ${LG_WIDTH}px) {
      font-size: ${rem(13)};
      line-height: ${rem(21)};
    }
  `,
};

export const typography = {
  headings,
  bodyText,
};
